import { FC } from 'react';
import { Severity, Status } from '@agilelab/plugin-wb-governance-common';
import { TestStatus } from '@agilelab/plugin-wb-platform';
import { Box, makeStyles, Typography } from '@material-ui/core';
// import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { Variant } from '@material-ui/core/styles/createTypography';

interface Task {
  status: any;
  policyStatus?: Status;
  severity?: Severity;
}

const useStyles = makeStyles(
  theme => ({
    header: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
  }),
  { name: 'PolicyHeader' },
);

interface Props {
  name: string;
  task: Task;
  style?: React.CSSProperties;
  titleVariant?: Variant;
}

export const PolicyHeader: FC<Props> = ({
  name,
  task,
  style,
  titleVariant = 'h6',
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.header} style={style}>
      <TestStatus
        filled
        status={task.status}
        policyStatus={task.policyStatus}
        severity={task.severity}
        variant="reduced"
      />
      <Typography
        variant={titleVariant}
        style={{ fontWeight: '700', marginBottom: 0 }}
      >
        {name}
      </Typography>
    </Box>
  );
};
